import axios from './axios';
import { User, UserRole } from '../types/models';

interface CreateUserData {
  email: string;
  full_name: string;
  password: string;
  is_active: boolean;
}

interface UpdateUserData {
  email?: string;
  full_name?: string;
  password?: string;
  is_active?: boolean;
}

// Helper function to convert UserRole values to backend format
const convertRolesToBackendFormat = (roles: UserRole[]): string[] => {
  // The UserRole enum values already match the backend format
  return roles as string[];
};

export const userApi = {
  async getUsers(): Promise<User[]> {
    const response = await axios.get('/users');
    return response.data;
  },

  async getUser(id: number): Promise<User> {
    const response = await axios.get(`/users/${id}`);
    return response.data;
  },

  async createUser(data: CreateUserData): Promise<User> {
    const response = await axios.post('/users', data);
    return response.data;
  },

  async updateUser(id: number, data: UpdateUserData): Promise<User> {
    const response = await axios.put(`/users/${id}`, data);
    return response.data;
  },

  async deleteUser(id: number): Promise<void> {
    try {
      await axios.delete(`/users/${id}`);
    } catch (error: any) {
      // Enhance the error object with more detailed information
      if (error.response?.data?.detail) {
        error.message = error.response.data.detail;
      }
      throw error;
    }
  }
};
